import React from 'react'
import cx from 'classnames'

const TextLink = ({ text, url, textCx, tileHover = false, cxNames = '' }) => {
  const defaultCx = 'color-inherit decoration-inherit'

  return (
    <div className={cx('arrow flex w-max-content pointer', cxNames, { 'arrow-link': !tileHover })}>
      <a href={url} className={cx('dib', defaultCx, textCx)}>
        {text}
      </a>
    </div>
  )
}

export default TextLink
